import { useContext, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

export default function useOrders() {
  const { api } = useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

 const getAllCatalogueOrders = async ({
   adminId,
   userid = "",
   statuses = [],
   fromdate = "",
   todate = "",
   latitude = "",
   longitude = "",
   limit = 100,
   offset = 0,
 }) => {
   try {
     const payload = {
       adminId: String(adminId || ""),
       userid: String(userid || ""),
       statuses: Array.isArray(statuses) ? statuses : [],
       fromdate: String(fromdate || ""),
       todate: String(todate || ""),
       latitude: String(latitude || ""),
       longitude: String(longitude || ""),
       limit: Number(limit) || 100,
       offset: Number(offset) || 0,
     };

     const res = await api.post(
       "/Admin/v3.0/getAllClientsCatalogueOrdersV3",
       payload,
     );

     if (res?.data?.responseCode === "00") {
       return {
         success: true,
         data: Array.isArray(res?.data?.response) ? res.data.response : [],
         message: res?.data?.responseMessage || "Orders fetched successfully",
       };
     }

     return {
       success: false,
       message:
         res?.data?.responseMessage || "Failed to fetch catalogue orders",
       data: [],
     };
   } catch (error) {
     console.error("getAllCatalogueOrders error:", error);

     return {
       success: false,
       message:
         error?.response?.data?.responseMessage ||
         error?.message ||
         "Error loading catalogue orders",
       data: [],
     };
   }
 };

  const getOrderDetails = useCallback(
    async (orderid) => {
      try {
        const res = await api.post("/Order/v1.0/getOrderDetails", { orderid });

        if (res?.data?.responseCode === "00") {
          return res?.data?.response || {};
        } else {
          toast.error(
            res?.data?.responseMessage || "Failed to fetch order details",
          );
          return {};
        }
      } catch (e) {
        console.error("getOrderDetails error:", e);
        toast.error("Error fetching order details");
        return {};
      }
    },
    [api],
  );

  const updateOrderPaymentStatus = async (orderid) => {
    try {
      const r = await api.post("/Order/v1.0/updateOrderPaymentStatus", {
        orderid,
      });

      if (r?.data?.responseCode === "00") {
        return {
          success: true,
          data: r?.data?.response || {},
          message: r?.data?.responseMessage || "Payment updated",
        };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Update failed",
          data: {},
        };
      }
    } catch (e) {
      console.error("updateOrderPaymentStatus error:", e);
      return {
        success: false,
        message: "Error updating payment",
        data: {},
      };
    }
  };
  const requestCustomerAddress = async (orderid) => {
    try {
      const r = await api.post("/Whatsapp/v1.0/locationRequest", { orderid });

      if (r?.data?.responseCode === "00") {
        return { success: true };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Failed to send request",
        };
      }
    } catch (e) {
      console.error("locationRequest error:", e);
      return {
        success: false,
        message: "Error sending request",
      };
    }
  };
  const assignDeliveryPartner = async ({ userid, orderId, paymentMode }) => {
    try {
      const payload = {
        userid: userid,
        orderId,
        platform: "whatsapp",
        paymentMode: paymentMode || null,
        deliveryPartner: "packky",
      };

      const r = await api.post("/Order/v1.0/assignDeliveryPartner", payload);

      if (r?.data?.responseCode === "00") {
        return { success: true };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Failed to send order",
        };
      }
    } catch (e) {
      console.error("assignDeliveryPartner error:", e);
      return {
        success: false,
        message: "Error forwarding order",
      };
    }
  };

  const changeCatalogueOrderStatus = async ({
    clientUserId,
    orderid,
    chosenStatus,
  }) => {
    try {
      const requestBody = {
        userid: clientUserId,
        orderid,
        productid: "",
        status: chosenStatus,
        time: "",
        payment: "",
      };

      const r = await api.post(
        "/Whatsapp/changeCatelogOrderStatus",
        requestBody,
      );

      if (r?.data?.responseCode === "00") {
        return { success: true };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Failed to update status",
        };
      }
    } catch (e) {
      console.error("changeCatelogOrderStatus error:", e);
      return {
        success: false,
        message: "Failed to update status",
      };
    }
  };

  const getRefundReport = async (userid = "") => {
    try {
      const r = await api.post("/Transactions/v1.0/getRefundReport", {
        userid: "",
      });

      if (r?.data?.responseCode === "00") {
        return {
          success: true,
          data: r.data.response || [],
        };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Failed to fetch refunds",
          data: [],
        };
      }
    } catch (e) {
      console.error("getRefundReport error:", e);
      return {
        success: false,
        message: "Error fetching refunds",
        data: [],
      };
    }
  };

  const processRefund = async ({ userid, amount, transactionId, remark }) => {
    try {
      const payload = {
        userid,
        amount,
        transactionId,
        remark,
      };

      const res = await api.post("/Transactions/v1.0/refundProccess", payload);

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message: res?.data?.responseMessage || "Refund initiated",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Refund failed",
        };
      }
    } catch (e) {
      console.error("refundProccess error:", e);
      return {
        success: false,
        message: "Error processing refund",
      };
    }
  };
  // const easebuzzRefund = async ({ orderId, amount, remark }) => {
  //   try {
  //     const payload = {
  //       orderId,
  //       amount: parseInt(amount),
  //       remark,
  //     };

  //     const res = await api.post("/Order/easebuzzRefund", payload);

  //     if (res?.data?.responseCode === "00") {
  //       return {
  //         success: true,
  //         message: res?.data?.responseMessage || "Easebuzz refund initiated",
  //         data: res?.data?.response || {},
  //       };
  //     } else {
  //       return {
  //         success: false,
  //         message: res?.data?.responseMessage || "Easebuzz refund failed",
  //         data: res?.data?.response || {},
  //       };
  //     }
  //   } catch (e) {
  //     console.error("easebuzzRefund error:", e);
  //     return {
  //       success: false,
  //       message: "Error processing Easebuzz refund",
  //       data: {},
  //     };
  //   }
  // };
  const refundV1 = async ({ orderId, amount, remark, type }) => {
  try {
    const payload = {
      orderId: String(orderId),
      amount: Number(amount),
      remark: String(remark || "").trim(),
      type: String(type || ""),
    };

    const res = await api.post("/Order/RefundV1", payload);

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message: res?.data?.responseMessage || "Refund initiated successfully",
        data: res?.data?.response || {},
      };
    }

    return {
      success: false,
      message: res?.data?.responseMessage || "Refund failed",
      data: res?.data?.response || {},
    };
  } catch (error) {
    console.error("refundV1 error:", error);

    return {
      success: false,
      message:
        error?.response?.data?.responseMessage ||
        error?.message ||
        "Error processing refund",
      data: {},
    };
  }
};
  const generatePaymentIntentApi = async ({
    userid,
    orderId,
    custName,
    custMobile,
  }) => {
    try {
      const payload = {
        userid,
        orderId,
        custName,
        custMobile,
      };

      const r = await api.post("/Order/generatePaymentIntent", payload);

      if (r?.data?.responseCode === "00") {
        return {
          success: true,
          message: r?.data?.responseMessage || "Link sent",
        };
      } else {
        return {
          success: false,
          message: r?.data?.responseMessage || "Error generating link",
        };
      }
    } catch (e) {
      console.error("generatePaymentIntent error:", e);
      return {
        success: false,
        message: "Error generating link",
      };
    }
  };

  const getCatalogueStatus = async (userid) => {
    try {
      const { data } = await api.post("/Whatsapp/getCatalogueStatus", {
        userid,
      });

      if (data?.responseCode === "00") {
        return {
          success: true,
          status: data.response?.catalogueStatus || "",
        };
      } else {
        return {
          success: false,
          message: data?.responseMessage || "Failed to load catalogue status",
          status: "",
        };
      }
    } catch (e) {
      console.error("getCatalogueStatus error:", e);
      return {
        success: false,
        message: "Error loading catalogue status",
        status: "",
      };
    }
  };
  const changeCatalogueStatus = async ({ userid, status }) => {
    try {
      const { data } = await api.post("/Whatsapp/changeCatalogueStatus", {
        userid,
        secret: "string",
        status,
      });

      if (data?.responseCode === "00") {
        return {
          success: true,
          message: data?.responseMessage || "Updated",
        };
      } else {
        return {
          success: false,
          message: data?.responseMessage || "Failed",
        };
      }
    } catch (e) {
      console.error("changeCatalogueStatus error:", e);
      return {
        success: false,
        message: "Failed to update",
      };
    }
  };

  const getPosOrders = async (payload) => {
    try {
      const res = await api.post("/Order/v3.0/getPosOrders", payload);

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
          message: res?.data?.responseMessage || "",
        };
      } else {
        return {
          success: false,
          data: [],
          message: res?.data?.responseMessage || "Failed to fetch orders",
        };
      }
    } catch (e) {
      console.error("getPosOrders error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching orders",
      };
    }
  };
  const getPaytmTransactionStatus = async (orderid) => {
    try {
      const res = await api.post("/Order/getPaytmTransactionStatus", {
        orderid: String(orderid),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data || {},
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to fetch status",
          data: res?.data || null,
        };
      }
    } catch (e) {
      console.error("getPaytmTransactionStatus error:", e);

      return {
        success: false,
        message: "Error checking payment status",
        data: null,
      };
    }
  };
  const generatePaymentIntent = async (payload) => {
    try {
      const res = await api.post("/Order/generatePaymentIntentV1", payload);

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message: res?.data?.responseMessage || "Payment link sent",
          data: res?.data?.response || {},
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Error generating link",
          data: {},
        };
      }
    } catch (e) {
      console.error("generatePaymentIntent error:", e);

      return {
        success: false,
        message: "Error generating payment link",
        data: {},
      };
    }
  };
    const generatePaymentIntent1 = async (payload) => {
    try {
      const res = await api.post("/Order/v2.0/generatePaymentIntentv2", payload);

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message: res?.data?.responseMessage || "Payment link sent",
          data: res?.data?.response || {},
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Error generating link",
          data: {},
        };
      }
    } catch (e) {
      console.error("generatePaymentIntent error:", e);

      return {
        success: false,
        message: "Error generating payment link",
        data: {},
      };
    }
  };
  const getAllEaseBuzzRefund = async ({ page = 1, limit = 20 } = {}) => {
    try {
      const res = await api.post(
        `/Order/getAllEaseBuzzRefund?page=${page}&limit=${limit}`,
      );

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
          message: res?.data?.responseMessage || "Easebuzz refunds fetched",
        };
      } else {
        return {
          success: false,
          data: [],
          message:
            res?.data?.responseMessage || "Failed to fetch Easebuzz refunds",
        };
      }
    } catch (e) {
      console.error("getAllEaseBuzzRefund error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching Easebuzz refunds",
      };
    }
  };

  const checkStatusEasebuzzRefund = async ({
    easebuzz_id,
    merchant_refund_id = "",
    refund_amount = 0,
    key = "",
    hash = "",
  }) => {
    try {
      const payload = {
        key,
        merchant_refund_id,
        easebuzz_id,
        refund_amount,
        hash,
      };

      const res = await api.post("/Order/CheckStatusEasebuzzRefund", payload);

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data || {},
          message: res?.data?.responseMessage || "Refund status fetched",
        };
      } else {
        return {
          success: false,
          data: res?.data || null,
          message:
            res?.data?.responseMessage || "Failed to fetch refund status",
        };
      }
    } catch (e) {
      console.error("checkStatusEasebuzzRefund error:", e);
      return {
        success: false,
        data: null,
        message: "Error fetching refund status",
      };
    }
  };

  const getPosDiscountList = async (userid) => {
    try {
      const res = await api.post("/Order/v2.0/getPosDiscountList", { userid });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
          message: res?.data?.responseMessage || "Discount list fetched",
        };
      }

      return {
        success: false,
        data: [],
        message: res?.data?.responseMessage || "Failed to fetch discount list",
      };
    } catch (e) {
      console.error("getPosDiscountList error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching discount list",
      };
    }
  };

  const updatePosDiscount = async ({
    userid,
    discount,
    discountType,
    orderType,
  }) => {
    try {
      const res = await api.post("/Order/v1.0/updatePosDiscount", {
        userid,
        discount,
        chargeType: discountType,
        orderType,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Discount updated successfully",
          data: res?.data?.response || {},
        };
      }

      return {
        success: false,
        message: res?.data?.responseMessage || "Failed to update discount",
        data: {},
      };
    } catch (e) {
      console.error("updatePosDiscount error:", e);
      return {
        success: false,
        message: "Error updating discount",
        data: {},
      };
    }
  };

  const deletePosDiscount = async ({ userid, discountId }) => {
    try {
      const res = await api.post("/Order/v1.0/deletePosDiscount", {
        userid,
        discountId,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message: res?.data?.responseMessage || "Discount removed",
        };
      }

      return {
        success: false,
        message: res?.data?.responseMessage || "Failed to remove discount",
      };
    } catch (e) {
      console.error("deletePosDiscount error:", e);
      return {
        success: false,
        message: "Error removing discount",
      };
    }
  };

  const getPosPackkyDeliveryCharges = async (userid) => {
    try {
      const res = await api.post(
        `/Order/getPosPackkyDeliveryCharges?fkuserid=${userid}`,
        {},
      );

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
          message: res?.data?.responseMessage || "Delivery charges fetched",
        };
      }

      return {
        success: false,
        data: [],
        message:
          res?.data?.responseMessage || "Failed to fetch delivery charges",
      };
    } catch (e) {
      console.error("getPosPackkyDeliveryCharges error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching delivery charges",
      };
    }
  };

  const getReceiptData = async (userid) => {
    try {
      const res = await api.post("/Order/getReceiptData", { userid });

      if (res?.data?.responseCode === "00") {
        const raw = Array.isArray(res?.data?.response)
          ? res.data.response[0]
          : null;

        let parsedSettings = [];
        if (raw?.printSettings) {
          try {
            parsedSettings =
              typeof raw.printSettings === "string"
                ? JSON.parse(raw.printSettings)
                : raw.printSettings;
          } catch (err) {
            console.error("printSettings parse error:", err);
          }
        }

        return {
          success: true,
          data: {
            ...raw,
            printSettings: Array.isArray(parsedSettings) ? parsedSettings : [],
          },
          message: res?.data?.responseMessage || "Receipt data fetched",
        };
      }

      return {
        success: false,
        data: null,
        message: res?.data?.responseMessage || "Failed to fetch receipt data",
      };
    } catch (e) {
      console.error("getReceiptData error:", e);
      return {
        success: false,
        data: null,
        message: "Error fetching receipt data",
      };
    }
  };

  const updatePrintSettings = async ({ userid, printConfig }) => {
    try {
      const res = await api.post("/Order/v1.0/updatePrintSettings", {
        userid,
        printConfig,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data?.response || {},
          message:
            res?.data?.responseMessage || "Print settings updated successfully",
        };
      }

      return {
        success: false,
        data: {},
        message:
          res?.data?.responseMessage || "Failed to update print settings",
      };
    } catch (e) {
      console.error("updatePrintSettings error:", e);
      return {
        success: false,
        data: {},
        message: "Error updating print settings",
      };
    }
  };
  const getPosOrderCustomizations = async (userid) => {
    try {
      const res = await api.post("/Order/v1.0/getPosOrderCustomizations", {
        userid,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
          message: res?.data?.responseMessage || "Customizations fetched",
        };
      }

      return {
        success: false,
        data: [],
        message: res?.data?.responseMessage || "Failed to fetch customizations",
      };
    } catch (e) {
      console.error("getPosOrderCustomizations error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching customizations",
      };
    }
  };

  const addPosOrderCustomization = async ({
    userid,
    customization,
    customizationType,
  }) => {
    try {
      const res = await api.post("/Order/v1.0/Pos/addCustomization", {
        userid,
        customization,
        customizationType,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data?.response || {},
          message:
            res?.data?.responseMessage || "Customization added successfully",
        };
      }

      return {
        success: false,
        data: {},
        message: res?.data?.responseMessage || "Failed to add customization",
      };
    } catch (e) {
      console.error("addPosOrderCustomization error:", e);
      return {
        success: false,
        data: {},
        message: "Error adding customization",
      };
    }
  };

  const deletePosOrderCustomization = async ({ userid, customizationId }) => {
    try {
      const res = await api.post("/Order/v1.0/Pos/deleteCustomization", {
        userid,
        customizationId,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Customization deleted successfully",
        };
      }

      return {
        success: false,
        message: res?.data?.responseMessage || "Failed to delete customization",
      };
    } catch (e) {
      console.error("deletePosOrderCustomization error:", e);
      return {
        success: false,
        message: "Error deleting customization",
      };
    }
  };

  const getPosPaymentMethods = async (userid) => {
    try {
      const res = await api.post("/Order/getReceiptData", { userid });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.paymentMethods)
            ? res.data.paymentMethods
            : [],
          message: res?.data?.responseMessage || "Payment methods fetched",
        };
      }

      return {
        success: false,
        data: [],
        message:
          res?.data?.responseMessage || "Failed to fetch payment methods",
      };
    } catch (e) {
      console.error("getPosPaymentMethods error:", e);
      return {
        success: false,
        data: [],
        message: "Error fetching payment methods",
      };
    }
  };

  const addPosPaymentMethod = async ({ userid, paymentMethod }) => {
    try {
      const res = await api.post("/Order/v1.0/Pos/addPaymentMethodOption", {
        userid,
        paymentMethod,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data?.response || {},
          message:
            res?.data?.responseMessage || "Payment method added successfully",
        };
      }

      return {
        success: false,
        data: {},
        message: res?.data?.responseMessage || "Failed to add payment method",
      };
    } catch (e) {
      console.error("addPosPaymentMethod error:", e);
      return {
        success: false,
        data: {},
        message: "Error adding payment method",
      };
    }
  };

  const deletePosPaymentMethod = async ({ userid, paymentMethodId }) => {
    try {
      const res = await api.post("/Order/v1.0/Pos/deletePaymentMethodOption", {
        userid,
        paymentMethodId,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Payment method deleted successfully",
        };
      }

      return {
        success: false,
        message:
          res?.data?.responseMessage || "Failed to delete payment method",
      };
    } catch (e) {
      console.error("deletePosPaymentMethod error:", e);
      return {
        success: false,
        message: "Error deleting payment method",
      };
    }
  };
  const insertPosPackkyDeliveryCharges = async ({ fkuserid, amount }) => {
    try {
      const res = await api.post(
        "/Order/InsertPosPackkyDeliveryCharges",
        null,
        {
          params: {
            fkuserid,
            amount,
          },
        },
      );

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data?.response || {},
          message:
            res?.data?.responseMessage ||
            "Delivery charges updated successfully",
        };
      }

      return {
        success: false,
        data: {},
        message:
          res?.data?.responseMessage || "Failed to update delivery charges",
      };
    } catch (e) {
      console.error("insertPosPackkyDeliveryCharges error:", e);
      return {
        success: false,
        data: {},
        message: "Error updating delivery charges",
      };
    }
  };
  const checkEasebuzzTransaction = async (txnID) => {
    try {
      const res = await api.post("/Order/CheckEasebuzzTransaction", {
        txnID: String(txnID),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data || {},
          message: res?.data?.responseMessage || "Successfully fetched.",
        };
      } else {
        return {
          success: false,
          data: res?.data || null,
          message:
            res?.data?.responseMessage ||
            "Failed to fetch Easebuzz transaction",
        };
      }
    } catch (e) {
      console.error("checkEasebuzzTransaction error:", e);
      return {
        success: false,
        data: null,
        message: "Error checking Easebuzz transaction",
      };
    }
  };

return {
    clients,
    orders,
    loading,
    busy,
    getOrderDetails,
    updateOrderPaymentStatus,
    requestCustomerAddress,
    getAllCatalogueOrders,
    assignDeliveryPartner,
    changeCatalogueOrderStatus,
    getRefundReport,
    processRefund,
    // easebuzzRefund,
    refundV1,
    getAllEaseBuzzRefund,
    checkStatusEasebuzzRefund,
    generatePaymentIntentApi,
    getCatalogueStatus,
    changeCatalogueStatus,
    getPosOrders,
    getPaytmTransactionStatus,
    checkEasebuzzTransaction, // add this
    generatePaymentIntent,
    generatePaymentIntent1,
    getPosDiscountList,
    updatePosDiscount,
    deletePosDiscount,
    getPosPackkyDeliveryCharges,
    getReceiptData,
    updatePrintSettings,
    getPosOrderCustomizations,
    addPosOrderCustomization,
    deletePosOrderCustomization,
    getPosPaymentMethods,
    addPosPaymentMethod,
    deletePosPaymentMethod,
    insertPosPackkyDeliveryCharges,
  };
}
